module.exports = __webpack_public_path__ + "img/logo.27ebac19.png";